import axios from 'axios'
import moment from 'moment/moment'
import { docCookies } from 'utils/docCookies'
import TripsApi from 'api/entities/TripsApi'
import UsersApi from 'api/entities/UsersApi'
import MembersApi from 'api/entities/MembersApi'
import MiscApi from 'api/entities/MiscApi'
import ProgramsApi from 'api/entities/ProgramsApi'
import TeamsApi from 'api/entities/TeamsApi'
import InvitesApi from 'api/entities/InvitesApi'
import SubscriptionsApi from 'api/entities/SubscriptionsApi'
import ExportsApi from 'api/entities/ExportsApi'
import ReportsApi from 'api/entities/ReportsApi'
import ComplianceApi from 'api/entities/ComplianceApi'
import TransactionsApi from 'api/entities/TransactionsApi'
import SchedulesApi from 'api/entities/SchedulesApi'
import PayPeriodsApi from 'api/entities/PayPeriodsApi'
import TagsApi from 'api/entities/TagsApi'
import PlacesApi from 'api/entities/PlacesApi'
import UnitApi from 'api/entities/UnitApi'
import RulesApi from 'api/entities/RulesApi'
import IntegrationsApi from 'api/entities/IntegrationsApi'

const defaultConfig = {
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    Authorization: docCookies.getItem('auth_token')
      ? `Token token=${docCookies.getItem('auth_token')}`
      : '',
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    'X-Api-Key': process.env.REACT_APP_X_API_KEY!
  }
}

const nonVersionConfig = {
  baseURL: process.env.REACT_APP_API_BASE_URL.replace('v6/', ''),
  headers: {
    Authorization: docCookies.getItem('auth_token')
      ? `Token token=${docCookies.getItem('auth_token')}`
      : '',
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    'X-Api-Key': process.env.REACT_APP_X_API_KEY!
  }
}

class APIService {
  private axiosInstance = axios.create(defaultConfig)
  private axiosInstanceNoneVersion = axios.create(nonVersionConfig)
  // Entities
  trips: TripsApi
  users: UsersApi
  members: MembersApi
  misc: MiscApi
  programs: ProgramsApi
  teams: TeamsApi
  invites: InvitesApi
  subscriptions: SubscriptionsApi
  exports: ExportsApi
  reports: ReportsApi
  compliance: ComplianceApi
  transactions: TransactionsApi
  schedules: SchedulesApi
  payPeriods: PayPeriodsApi
  tags: TagsApi
  places: PlacesApi
  unit: UnitApi
  rules: RulesApi
  integrations: IntegrationsApi

  constructor() {
    this.axiosInstance.interceptors.request.use(
      (config) => {
        const token = docCookies.getItem('auth_token')
        config.headers['Authorization'] = token ? `Token token=${token}` : ''

        if (config?.headers) {
          config.headers['request_send_at'] = moment().format()
        }
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )

    this.trips = new TripsApi(this.axiosInstance)
    this.users = new UsersApi(this.axiosInstance)
    this.members = new MembersApi(this.axiosInstance)
    this.misc = new MiscApi(this.axiosInstance, this.axiosInstanceNoneVersion)
    this.programs = new ProgramsApi(this.axiosInstance)
    this.teams = new TeamsApi(this.axiosInstance)
    this.invites = new InvitesApi(this.axiosInstance)
    this.subscriptions = new SubscriptionsApi(this.axiosInstance)
    this.exports = new ExportsApi(this.axiosInstance)
    this.reports = new ReportsApi(this.axiosInstance)
    this.compliance = new ComplianceApi(this.axiosInstance)
    this.transactions = new TransactionsApi(this.axiosInstance)
    this.schedules = new SchedulesApi(this.axiosInstance)
    this.payPeriods = new PayPeriodsApi(this.axiosInstance)
    this.tags = new TagsApi(this.axiosInstance)
    this.places = new PlacesApi(this.axiosInstance)
    this.unit = new UnitApi(this.axiosInstance)
    this.rules = new RulesApi(this.axiosInstance)
    this.integrations = new IntegrationsApi(this.axiosInstance)
  }
}

const API = new APIService()
export default API
